import { isLocalhostOrPreview, isStaging } from 'src/utils/url'

export const TEST_MODE_KEY = 'testMode'
export const TEST_MODE_VALUE = 'true'

export const shouldPosthogTrack = () => {
  return localStorage.getItem(TEST_MODE_KEY) !== TEST_MODE_VALUE && !isStaging() && !isLocalhostOrPreview
}
